"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _merge2 = _interopRequireDefault(require("lodash/merge"));

var _compact2 = _interopRequireDefault(require("lodash/compact"));

var _flattenDeep2 = _interopRequireDefault(require("lodash/flattenDeep"));

/**
 * Merges { className, style } objects together into a single object.
 */
var mergeStyles = function mergeStyles() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var _args$reduce = args.reduce(function (memo, _ref) {
    var className = _ref.className,
        style = _ref.style;
    memo.classNameProps.push(className);
    memo.styleProps.push(style);
    return memo;
  }, {
    classNameProps: [],
    styleProps: []
  }),
      classNameProps = _args$reduce.classNameProps,
      styleProps = _args$reduce.styleProps;

  classNameProps = (0, _flattenDeep2.default)((0, _compact2.default)(classNameProps));
  styleProps = (0, _flattenDeep2.default)((0, _compact2.default)(styleProps));
  return {
    className: classNameProps.length ? classNameProps.join(' ') : undefined,
    style: styleProps.length ? _merge2.default.apply(void 0, [{}].concat((0, _toConsumableArray2.default)(styleProps))) : undefined
  };
};

var _default = mergeStyles;
exports.default = _default;